
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class SalesApprovalItemsGrid extends _Ext.GridBase<ApprovalOutItemsRow, any> {
        protected getColumnsKey() { return 'Sales.ApprovalOutItems'; }
        protected getDialogType() { return ApprovalOutItemsDialog; }
        protected getIdProperty() { return ApprovalOutItemsRow.idProperty; }
        protected getInsertPermission() { return ApprovalOutItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return ApprovalOutItemsRow.localTextPrefix; }
        protected getService() { return SalesApprovalItemsService.baseUrl; }
        public rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize; 
        protected getColumns() {

            var _this = this;
            var columns = super.getColumns.call(this);
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));
            return columns;
        };

        constructor(container: JQuery, options) {
            super(container, options);
            (this.view.params as TransactionRequest).PartyId = options.GridFilters.PartyId; 
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });

        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.editable = true;
            opt.autoEdit = true;
            //opt.forceFitColumns = true;
            return opt;
        }
        get selectedItems(): ApprovalOutItemsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }
    }

}